module.exports = __webpack_public_path__ + "img/don40-login.7bcd0d04.png";